import React from 'react';

export const InProgressIllustration = () => (
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M87.4313 53.6023C86.8014 51.8486 85.8631 50.2217 84.6608 48.7981C82.1907 45.7768 78.6347 43.8442 74.7558 43.415C70.7693 43.0075 66.7797 44.1594 63.6239 46.6291C62.8377 47.2625 62.1582 48.0217 61.3553 48.6235C60.5524 49.2254 59.9813 49.454 59.2827 48.6212C58.2209 47.1462 59.4636 48.4471 57.8453 47.62C56.2926 48.2175 54.0735 50.6631 52 51.5C49.8865 52.8353 48.6979 53.8793 47 55C43.522 57.3092 38.5925 59.6556 39.2309 60.6658C39.9998 61.0917 40.8499 61.1343 42.7855 61.0917L57.7557 60.6658L73.1344 60.2549L80.6195 60.0419L84.3626 59.9594C85.4504 59.9354 86.6511 59.957 87.4643 59.0909C88.8016 57.6851 87.9944 55.1902 87.4313 53.6023Z"
      fill="#F1F1F1"
    />
    <path
      d="M40.5983 31.7752C40.192 30.4897 39.557 29.2881 38.7238 28.2283C37.0171 26.004 34.506 24.5381 31.73 24.1455C28.8686 23.7495 25.9651 24.4792 23.6309 26.1811C23.0542 26.6122 22.5414 27.1394 21.9488 27.5545C21.3561 27.9696 20.9399 28.129 20.4609 27.5043C19.7269 26.4151 18.7437 25.5168 17.5929 24.8838C14.9549 23.5598 11.8503 23.939 9.21629 25.255C4.17239 27.7913 3.6907 34.1025 4.12956 34.8472C4.9274 36.2564 6.89572 36.0514 8.2877 36.0616L19.0636 36.1261L30.1435 36.1911L35.5355 36.1994L38.1915 36.2035C38.5837 36.2691 38.985 36.2566 39.3723 36.1666C39.7596 36.0765 40.1253 35.9108 40.4483 35.6789C41.4498 34.7445 40.9326 32.9277 40.5983 31.7752Z"
      fill="#F1F1F1"
    />
    <path
      d="M86.8093 84.2464C86.5332 83.3726 86.1015 82.5559 85.5352 81.8355C84.3752 80.3237 82.6683 79.3273 80.7815 79.0605C78.8365 78.7913 76.863 79.2873 75.2764 80.4441C74.8845 80.7371 74.5359 81.0955 74.1331 81.3776C73.7303 81.6597 73.4474 81.7681 73.1217 81.3434C72.6229 80.6031 71.9546 79.9925 71.1724 79.5623C69.3793 78.6623 67.2691 78.9201 65.4787 79.8146C62.0504 81.5385 61.723 85.8283 62.0213 86.3345C62.5635 87.2923 63.9014 87.153 64.8476 87.1599L72.172 87.2038L79.7031 87.2479L83.3681 87.2536L85.1734 87.2563C85.44 87.301 85.7127 87.2924 85.976 87.2312C86.2393 87.1701 86.4878 87.0574 86.7074 86.8998C87.3881 86.2646 87.0365 85.0297 86.8093 84.2464Z"
      fill="#F1F1F1"
    />
    <g opacity="0.8">
      <path
        d="M52.3608 15.1473L54.3037 19.5003"
        stroke="#00005A"
        strokeWidth="0.937409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.6773 33.8185L49.2098 33.7854C49.1971 33.965 49.2884 34.136 49.4447 34.2253C49.6009 34.3147 49.7946 34.3067 49.9429 34.2047L49.6773 33.8185ZM83.6759 10.4387L83.9415 10.8249C84.1213 10.7012 84.192 10.4698 84.1119 10.2667C84.0318 10.0637 83.8222 9.94279 83.6064 9.97517L83.6759 10.4387ZM52.3595 14.6622C52.1035 14.7006 51.9271 14.9392 51.9655 15.1952C52.0039 15.4512 52.2425 15.6276 52.4985 15.5892L52.429 15.1257L52.3595 14.6622ZM50.0564 28.453L49.5889 28.42L49.2098 33.7854L49.6773 33.8185L50.1449 33.8515L50.5239 28.4861L50.0564 28.453ZM49.6773 33.8185L49.9429 34.2047L83.9415 10.8249L83.6759 10.4387L83.4103 10.0525L49.4118 33.4323L49.6773 33.8185ZM83.6759 10.4387L83.6064 9.97517L52.3595 14.6622L52.429 15.1257L52.4985 15.5892L83.7454 10.9022L83.6759 10.4387Z"
        fill="#00005A"
      />
      <path
        d="M83.0504 10.7511L47.9323 21.7633L55.2244 25.0059"
        stroke="#00005A"
        strokeWidth="0.937409"
        strokeLinejoin="round"
      />
      <path
        opacity="0.8"
        d="M54.9054 27.7571L54.521 26.8249C54.4432 26.6443 54.297 26.5018 54.1145 26.4285C53.9319 26.3552 53.7278 26.3571 53.5467 26.4338L45.4425 29.7802C45.2579 29.8577 45.1114 30.0048 45.0347 30.1897C44.9946 30.2837 44.9746 30.385 44.9761 30.4871C44.9776 30.5892 45.0006 30.6899 45.0434 30.7826L45.4278 31.7148C45.4919 31.8748 45.61 32.0074 45.7615 32.0896C45.913 32.1719 46.0884 32.1986 46.2576 32.1653C46.3091 32.1591 46.3595 32.1456 46.4073 32.1252L54.5089 28.7691C54.6005 28.7325 54.6839 28.6779 54.7541 28.6086C54.8243 28.5392 54.8799 28.4566 54.9177 28.3654C54.9555 28.2743 54.9747 28.1765 54.9741 28.0778C54.9736 27.9791 54.9533 27.8816 54.9144 27.7909L54.9054 27.7571Z"
        fill="url(#paint0_linear_54704_27678)"
      />
    </g>
    <g opacity="0.8">
      <path
        d="M43.6011 72.2787L45.3368 76.1676"
        stroke="#00005A"
        strokeWidth="0.83747"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.2037 88.9593L40.786 88.9298C40.7746 89.0902 40.8562 89.243 40.9958 89.3228C41.1354 89.4026 41.3084 89.3955 41.4409 89.3043L41.2037 88.9593ZM71.5776 68.0721L71.8148 68.4171C71.9755 68.3066 72.0386 68.0999 71.9671 67.9185C71.8956 67.7371 71.7083 67.6291 71.5154 67.658L71.5776 68.0721ZM43.5998 71.8453C43.3711 71.8796 43.2135 72.0928 43.2478 72.3215C43.2821 72.5502 43.4954 72.7078 43.7241 72.6735L43.6619 72.2594L43.5998 71.8453ZM41.5423 84.1659L41.1246 84.1364L40.786 88.9298L41.2037 88.9593L41.6213 88.9888L41.96 84.1954L41.5423 84.1659ZM41.2037 88.9593L41.4409 89.3043L71.8148 68.4171L71.5776 68.0721L71.3403 67.7271L40.9664 88.6143L41.2037 88.9593ZM71.5776 68.0721L71.5154 67.658L43.5998 71.8453L43.6619 72.2594L43.7241 72.6735L71.6397 68.4862L71.5776 68.0721Z"
        fill="#00005A"
      />
      <path
        d="M71.0191 68.3512L39.645 78.1893L46.1597 81.0863"
        stroke="#00005A"
        strokeWidth="0.83747"
        strokeLinejoin="round"
      />
      <path
        opacity="0.8"
        d="M45.8747 83.5442L45.5313 82.7113C45.4617 82.55 45.3311 82.4227 45.1681 82.3572C45.005 82.2918 44.8226 82.2935 44.6608 82.362L37.4206 85.3516C37.2557 85.4208 37.1248 85.5523 37.0563 85.7174C37.0204 85.8014 37.0026 85.8919 37.004 85.9831C37.0053 86.0743 37.0258 86.1643 37.0641 86.2471L37.4075 87.0799C37.4648 87.2229 37.5702 87.3413 37.7056 87.4148C37.8409 87.4883 37.9977 87.5122 38.1488 87.4824C38.1949 87.4769 38.2399 87.4648 38.2826 87.4466L45.5204 84.4483C45.6023 84.4156 45.6767 84.3668 45.7395 84.3049C45.8022 84.2429 45.8519 84.1691 45.8857 84.0876C45.9194 84.0062 45.9366 83.9188 45.9361 83.8307C45.9356 83.7425 45.9174 83.6554 45.8827 83.5744L45.8747 83.5442Z"
        fill="url(#paint1_linear_54704_27678)"
      />
    </g>
    <g opacity="0.8">
      <path
        d="M15.9194 51.5483L18.8085 58.0214"
        stroke="#00005A"
        strokeWidth="1.39396"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9285 79.3131L11.2333 79.264C11.2144 79.531 11.3502 79.7852 11.5825 79.9181C11.8149 80.051 12.1029 80.0391 12.3235 79.8874L11.9285 79.3131ZM62.4856 44.5465L62.8806 45.1208C63.148 44.9369 63.2531 44.5927 63.134 44.2908C63.0149 43.9889 62.7032 43.8091 62.3822 43.8572L62.4856 44.5465ZM15.9169 50.8269C15.5363 50.884 15.274 51.2389 15.3311 51.6196C15.3882 52.0003 15.743 52.2626 16.1237 52.2055L16.0203 51.5162L15.9169 50.8269ZM12.4922 71.3345L11.797 71.2854L11.2333 79.264L11.9285 79.3131L12.6238 79.3622L13.1875 71.3836L12.4922 71.3345ZM11.9285 79.3131L12.3235 79.8874L62.8806 45.1208L62.4856 44.5465L62.0907 43.9722L11.5336 78.7388L11.9285 79.3131ZM62.4856 44.5465L62.3822 43.8572L15.9169 50.8269L16.0203 51.5162L16.1237 52.2055L62.589 45.2358L62.4856 44.5465Z"
        fill="#00005A"
      />
      <path
        d="M61.5569 45.0111L9.33493 61.3866L20.1786 66.2086"
        stroke="#00005A"
        strokeWidth="1.39396"
        strokeLinejoin="round"
      />
      <path
        opacity="0.8"
        d="M19.7043 70.2995L19.1328 68.9133C19.017 68.6447 18.7997 68.4328 18.5282 68.3238C18.2568 68.2149 17.9533 68.2177 17.6839 68.3317L5.6327 73.308C5.35822 73.4231 5.14027 73.642 5.02619 73.9169C4.96656 74.0566 4.9369 74.2072 4.93915 74.3591C4.94139 74.511 4.97548 74.6607 5.03922 74.7985L5.61076 76.1847C5.70619 76.4226 5.8817 76.6198 6.10699 76.7421C6.33228 76.8644 6.59321 76.9042 6.84472 76.8547C6.92139 76.8455 6.99635 76.8254 7.06734 76.795L19.1147 71.8044C19.2509 71.7499 19.3749 71.6687 19.4793 71.5657C19.5837 71.4626 19.6665 71.3396 19.7227 71.2041C19.7789 71.0685 19.8074 70.9231 19.8066 70.7764C19.8057 70.6297 19.7755 70.4846 19.7178 70.3497L19.7043 70.2995Z"
        fill="url(#paint2_linear_54704_27678)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_54704_27678"
        x1="44.9104"
        y1="30.208"
        x2="55.0232"
        y2="28.3118"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9F8A" />
        <stop offset="0.05" stopColor="#FF9793" />
        <stop offset="0.11" stopColor="#FF8AA4" />
        <stop offset="0.15" stopColor="#FF80B1" />
        <stop offset="0.24" stopColor="#FF66D2" />
        <stop offset="0.33" stopColor="#FF44FF" />
        <stop offset="0.66" stopColor="#4900FF" />
        <stop offset="1" stopColor="#00005A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_54704_27678"
        x1="36.9453"
        y1="85.7338"
        x2="45.9799"
        y2="84.0397"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9F8A" />
        <stop offset="0.05" stopColor="#FF9793" />
        <stop offset="0.11" stopColor="#FF8AA4" />
        <stop offset="0.15" stopColor="#FF80B1" />
        <stop offset="0.24" stopColor="#FF66D2" />
        <stop offset="0.33" stopColor="#FF44FF" />
        <stop offset="0.66" stopColor="#4900FF" />
        <stop offset="1" stopColor="#00005A" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_54704_27678"
        x1="4.84148"
        y1="73.944"
        x2="19.8795"
        y2="71.1243"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9F8A" />
        <stop offset="0.05" stopColor="#FF9793" />
        <stop offset="0.11" stopColor="#FF8AA4" />
        <stop offset="0.15" stopColor="#FF80B1" />
        <stop offset="0.24" stopColor="#FF66D2" />
        <stop offset="0.33" stopColor="#FF44FF" />
        <stop offset="0.66" stopColor="#4900FF" />
        <stop offset="1" stopColor="#00005A" />
      </linearGradient>
    </defs>
  </svg>
);
